var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("new-edit-page", {
    attrs: {
      "is-loading": _vm.loading,
      "page-title": _vm.pageTitle,
      "submit-button-label": _vm.submitButtonLabel,
      "submit-button-disabled": _vm.submitButtonDisabled
    },
    on: { submit: _vm.saveTemplate },
    scopedSlots: _vm._u([
      {
        key: "leftSideContent",
        fn: function() {
          return [
            _c(
              "form",
              {
                ref: "reservationTemplateForm",
                staticClass: "management-form"
              },
              [
                _c("div", { staticClass: "input-field-container medium" }, [
                  _c(
                    "label",
                    { staticClass: "required", attrs: { for: "label" } },
                    [_vm._v(_vm._s(_vm.$tc("Label", 1)))]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.template.label,
                        expression: "template.label"
                      }
                    ],
                    staticClass: "input-field",
                    attrs: { type: "text", id: "label", required: "" },
                    domProps: { value: _vm.template.label },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.template, "label", $event.target.value)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "input-field-container medium" },
                  [
                    _c("label", { staticClass: "required" }, [
                      _vm._v(_vm._s(_vm.$tc("Owner")))
                    ]),
                    _vm._v(" "),
                    _c("treeselect", {
                      attrs: {
                        options: _vm.ownerOptions,
                        "load-options": _vm.loadOwnerOptions,
                        normalizer: _vm.ownerOptionsNormalizer,
                        clearable: false,
                        disabled: _vm.actionType === "edit",
                        required: ""
                      },
                      model: {
                        value: _vm.template.owner_id,
                        callback: function($$v) {
                          _vm.$set(_vm.template, "owner_id", $$v)
                        },
                        expression: "template.owner_id"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "input-field-container large" },
                  [
                    _c("label", { staticClass: "required" }, [
                      _vm._v(" " + _vm._s(_vm.$tc("Layer", 2)) + " ")
                    ]),
                    _vm._v(" "),
                    _c("treeselect", {
                      attrs: {
                        options: _vm.layerOptions,
                        "default-expand-level": 1,
                        clearable: false,
                        disabled: _vm.actionType === "edit",
                        required: "",
                        multiple: ""
                      },
                      model: {
                        value: _vm.template.accepted_layers,
                        callback: function($$v) {
                          _vm.$set(_vm.template, "accepted_layers", $$v)
                        },
                        expression: "template.accepted_layers"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                !(_vm.actionType === "edit")
                  ? _c(
                      "div",
                      { staticClass: "input-field-container medium" },
                      [
                        _c("label", { staticClass: "required" }, [
                          _vm._v(" " + _vm._s(_vm.$t("Status")) + " ")
                        ]),
                        _vm._v(" "),
                        _c("treeselect", {
                          attrs: {
                            options: _vm.statusOptions,
                            "load-options": _vm.loadStatusOptions,
                            normalizer: _vm.normalizer,
                            clearable: false,
                            required: "",
                            multiple: ""
                          },
                          model: {
                            value: _vm.template.status,
                            callback: function($$v) {
                              _vm.$set(_vm.template, "status", $$v)
                            },
                            expression: "template.status"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "input-field-container medium" }, [
                  _c("label", { attrs: { for: "index" } }, [
                    _vm._v(_vm._s(_vm.$t("Index")))
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.template.index,
                        expression: "template.index"
                      }
                    ],
                    staticClass: "input-field",
                    attrs: {
                      type: "number",
                      step: "1",
                      id: "index",
                      max: 1000
                    },
                    domProps: { value: _vm.template.index },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.template, "index", $event.target.value)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "input-field-container medium" },
                  [
                    _c("label", [_vm._v(_vm._s(_vm.$t("Active")))]),
                    _vm._v(" "),
                    _c("v-switch", {
                      attrs: {
                        color: "accent",
                        label: _vm.template.active
                          ? _vm.$t("Yes")
                          : _vm.$t("No")
                      },
                      model: {
                        value: _vm.template.active,
                        callback: function($$v) {
                          _vm.$set(_vm.template, "active", $$v)
                        },
                        expression: "template.active"
                      }
                    })
                  ],
                  1
                )
              ]
            )
          ]
        },
        proxy: true
      },
      {
        key: "rightSideHeader",
        fn: function() {
          return [
            _c(
              "v-layout",
              { attrs: { row: "", "justify-end": "" } },
              [
                _c(
                  "v-btn",
                  {
                    attrs: {
                      "x-small": "",
                      text: "",
                      icon: "",
                      color: "accent"
                    },
                    on: { click: _vm.openRequestFieldForm }
                  },
                  [_c("v-icon", [_vm._v("add_circle")])],
                  1
                )
              ],
              1
            )
          ]
        },
        proxy: true
      },
      {
        key: "rightSideContent",
        fn: function() {
          return [
            _c("reservation-template-fields-list", {
              key: _vm.updated,
              attrs: {
                "request-fields": _vm.template.request_fields,
                "action-type": _vm.actionType
              },
              on: {
                "edit-item": _vm.openRequestFieldForm,
                "delete-item": _vm.deleteRequestField
              }
            }),
            _vm._v(" "),
            _vm.requestFieldForm.isOpen
              ? _c("reservation-template-field-form", {
                  attrs: {
                    open: _vm.requestFieldForm.isOpen,
                    "item-index": _vm.requestFieldForm.index,
                    "original-item": _vm.requestFieldForm.data,
                    "selected-fields": _vm.template.request_fields
                  },
                  on: {
                    add: _vm.addRequestField,
                    edit: _vm.editRequestField,
                    close: _vm.closeRequestFieldForm
                  }
                })
              : _vm._e()
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-eee37254", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eee37254","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AssetReservationManagement/Templates/ReservationTemplateCreateEdit.vue
// module id = null
// module chunks = 